module.exports = __webpack_public_path__ + "img/public-illustration.cae0d327.jpg";